import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { amazoneAccConnect, amazoneAdsConnect , getMarketPlaceAdata } from '../../../../services/marketPlaceConnection';

const useMarketPlaceModal = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [marketplaceData, setMarketplaceData] = useState([]); //  Declare state


  const getMarketplaces = async () =>{
    setLoading(true);
    try {
      let response = await getMarketPlaceAdata();
      if (response && response.success && response.data) {
        setMarketplaceData(response.data);
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      setLoading(false);
      console.error(`${name} connect failed:`, error);
    }
  }

  const handleConnect = async (marketplaceName) => {
    setLoading(true);
    try {
      let response;

      if (marketplaceName === "amazon") {
        response = await amazoneAccConnect();
      } else if (marketplaceName === "amazon ads") {
        response = await amazoneAdsConnect();
      } else {
        throw new Error("Unsupported marketplace: " + marketplaceName);
      }
      if (response && response.success && response.data?.auth_url) {
        const authUrl = response.data.auth_url;
        window.open(authUrl, '_self');
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      setLoading(false);
      console.error(`${name} connect failed:`, error);
    }
  };

  return {
    loading,
    handleConnect,
    marketplaceData,
    getMarketplaces
  };
};

export default useMarketPlaceModal;
